<template>
  <div>
    <b-modal id="modal-rs" title="Partager sur les réseaux sociaux" :hide-footer="true">
      <div class="d-flex justify-content-center">
        <a class="social-network twitter" target="_blank" :href="twitterLink()">
          <icon name="brands/twitter" />
        </a>
        <a class="social-network facebook" target="_blank" :href="facebookLink()">
          <icon name="brands/facebook-f" />
        </a>
        <a class="social-network linkedin" target="_blank" :href="linkedinLink()">
          <icon name="brands/linkedin" />
        </a>
        <a class="social-network viadeo" target="_blank" :href="viadeoLink()">
          <icon name="brands/viadeo" />
        </a>
      </div>
    </b-modal>
  </div>
</template>

<script>
import "vue-awesome/icons/brands/facebook-f";
import "vue-awesome/icons/brands/twitter";
import "vue-awesome/icons/brands/viadeo";
import "vue-awesome/icons/brands/linkedin";
export default {
  name: "Share.vue",
  props: ["score", "test-label", "exam-id"],
  methods: {
    twitterLink() {
      return `https://twitter.com/intent/tweet?text=${this.$t(
        "finished.twitter_score",
        { score: this.score, testName: this.testLabel }
      )}&hashtags=certificat,formation`; // le & permet d'integrer le #
    },
    facebookLink() {
      return `https://www.facebook.com/sharer/sharer.php?u=https://check.icdl.quebec/test/${this.examId}`;
    },
    linkedinLink() {
      return `http://www.linkedin.com/shareArticle?mini=true&url=https://check.icdl.quebec/test/${this.examId}`;
    },
    viadeoLink() {
      return `http://www.viadeo.com/shareit/share/?url=https://check.icdl.quebec/test/${this.examId}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/scss/vars";

.social-network {
  width: 30px;
  height: 30px;
  display: block;
  text-align: center;
  border: 1px solid $white;
  border-radius: 50%;
  margin: 0 5px;

  &.facebook {
    color: #fff;
    border-color: $facebook;
    background-color: $facebook !important;
  }

  &.twitter {
    color: #fff;
    border-color: $twitter;
    background-color: $twitter;
  }

  &.instagram {
    color: #ffffff;
    border-color: #d6249f;
    background: radial-gradient(
      circle at 30% 107%,
      #fdf497 0%,
      #fdf497 5%,
      #fd5949 45%,
      #d6249f 60%,
      #285aeb 90%
    );
  }

  &.linkedin {
    color: #fff;
    border-color: #0e76a8;
    background-color: #0e76a8;
  }

  &.viadeo {
    color: #fff;
    border-color: #fff;
    background-color: #f07355;
  }
}
</style>
